import React, { useEffect } from 'react';
import LoginForm from '../components/Login/LoginForm';
import { useDispatch, useSelector } from 'react-redux';
import { UserState, AppState, UserCredentials } from '../types';
import { firebaseLogin } from '../actions/user';
import { ErrorMsg } from '../constants/styles';
import { Redirect } from 'react-router';
import styled from 'styled-components';

const LoginRoot = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: flex-start;
`;

export default function EmailLogin(props: {}) {
  const dispatch = useDispatch();
  const {
    loggingIn,
    loginError,
    loginSuccess
  } = useSelector<AppState, UserState>(state => state.user);

  const login = (creds: { email: string, password: string }) => dispatch(firebaseLogin(creds));

  if (loginSuccess) {
    return <Redirect to ='/' />;
  }

  return (
    <LoginRoot>
      <h1>Iniciar sesión</h1>
      <LoginForm
        loggingIn={loggingIn}
        handleSubmit={values => login(values)}
      />
      {
        loginError && (
          <ErrorMsg>
            Error al iniciar sesión. Por favor intenta de nuevo.
          </ErrorMsg>
        )
      }
      {
        loggingIn && (
          <p>Iniciando sesión...</p>
        )
      }
    </LoginRoot>
  );
}